import React, { useState, useEffect } from "react";
import { Form, Input, Button, Modal, message, Divider } from "antd";
import { 
  MailOutlined, 
  LockOutlined, 
  EyeInvisibleOutlined, 
  EyeTwoTone,
  ArrowRightOutlined,
  KeyOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "../assets/css/LoginForm.css";
import Api from "../api/Api";
import logo from "../assets/img/logo.png";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LoginForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "TECH NEXT CRM - LOGIN";
  }, []);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const result = await Api.Login(values);

      if (result.success) {
        toast.success("Login efetuado com sucesso!");
        localStorage.setItem("user", JSON.stringify(result.user));
         localStorage.setItem("loginTime", Date.now());
        navigate("/dashboard");
      } 
      else if(result.message==='Ativar')
      {
        toast.error("Deve fazer a activação da conta");
      }
      
      else if(result.message==='Recuperar')
      {
        toast.error("Recuperação de senha");
      }
      
      else {
        toast.error("E-mail ou senha incorretos.");
      }
    } catch (error) {
      toast.error("Erro ao fazer login.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
            <ToastContainer position="top-right" />
      {/* Background com efeito de partículas visuais */}
      <div className="background-overlay">
        <div className="gradient-animation"></div>
      </div>

      {/* CARD PRINCIPAL */}
      <div 
        className="login-card"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* LADO ESQUERDO - FORMULÁRIO */}
        <div className="left-panel">
          <div className="form-header">
            <h1 className="form-title">Bem-vindo de volta</h1>
            <p className="form-subtitle">Faça login para acessar sua conta</p>
          </div>

          <Form 
            form={form} 
            layout="vertical" 
            onFinish={onFinish} 
            className="form-area"
            size="large"
          >
            <Form.Item
              name="email"
              rules={[
                { 
                  required: true, 
                  message: "Por favor, insira seu e-mail" 
                },
                { 
                  type: 'email', 
                  message: 'E-mail inválido' 
                }
              ]}
            >
              <Input
                prefix={<MailOutlined className="input-icon" />}
                placeholder="Seu e-mail corporativo"
                className="modern-input"
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { 
                  required: true, 
                  message: "Por favor, insira sua senha" 
                },
                {
                  min:4,
                  message: "A senha deve ter pelo menos 4 caracteres"
                }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="input-icon" />}
                placeholder="Sua senha"
                iconRender={(visible) => 
                  visible ? 
                  <EyeTwoTone /> : 
                  <EyeInvisibleOutlined />
                }
                className="modern-input"
                autoComplete="current-password"
              />
            </Form.Item>

            <div className="form-options">
               
              
              <Button 
                type="link" 
                onClick={() => setModalVisible(true)}
                className="forgot-password-link"
              >
                <KeyOutlined /> Esqueci minha senha
              </Button>
            </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="btn-primary-gradient"
                icon={<ArrowRightOutlined />}
                iconPosition="end"
              >
                {loading ? "Entrando..." : "Login"}
              </Button>
            </Form.Item>

            <Divider className="divider">
              <span className="divider-text">ou</span>
            </Divider>

            <div className="alternative-login">
  <p className="signup-text">
    © {new Date().getFullYear()} Tech Next. Todos os direitos reservados.
  </p>
  <p className="signup-text">
    Versão 1.0.0
  </p>
</div>
          </Form>
        </div>

        {/* LADO DIREITO - APRESENTAÇÃO */}
        <div className="right-panel">
          <div className="right-content">
            <div className={`logo-container ${isHovered ? 'hovered' : ''}`}>
              <img src={logo} alt="TECH NEXT CRM" className="login-logo" />
            </div>
            
            <div className="welcome-message">
              <h2 className="welcome-title">
              Bem-vindo de volta.
              </h2>
              
              
            </div>
 
          </div>
        </div>
      </div>

      {/* MODAL DE RECUPERAÇÃO DE SENHA */}
      <Modal
        title={
          <div className="modal-header">
            <KeyOutlined style={{ marginRight: 8 }} />
            Recuperar senha
          </div>
        }
        open={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        className="recovery-modal"
        centered
      >
        <p className="modal-description">
          Insira seu e-mail cadastrado para receber as instruções de recuperação.
        </p>

        <Form
          layout="vertical"
          onFinish={() => {
            toast.success("Instruções enviadas para seu e-mail!");
            setModalVisible(false);
          }}
        >
          <Form.Item
            name="recoverEmail"
            rules={[
              { required: true, message: "Digite seu e-mail" },
              { type: 'email', message: 'E-mail inválido' }
            ]}
          >
            <Input 
              placeholder="seu.email@empresa.com" 
              prefix={<MailOutlined />}
              size="large"
            />
          </Form.Item>

          <div className="modal-actions">
            <Button
              type="default"
              onClick={() => setModalVisible(false)}
              className="btn-cancel"
            >
              Cancelar
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="btn-primary-gradient"
            >
              Enviar instruções
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default LoginForm;